<template>
  <v-dialog
    :value="open"
    content-class="cancelDialogA_dialog"
    max-width="395px"
    @click:outside="handleOutside"
  >
    <v-btn
      icon
      class="cancelDialogA_dialog-closeIcon"
      tabindex="-1"
      @click="$emit('onClose')"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="cancelDialogA_dialog-title">
        <span>{{ title }}</span>
      </v-card-title>

      <v-divider />
      <v-card-text class="cancelDialogA_dialog-text">
        <v-container class="cancelDialogA_dialog-container">
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="cancelDialogA_dialog-actions"
            >
              <slot name="actions" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CancelDialogA',
  props: {
    open: {
      type: Boolean,
    },
    title: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    handleOutside(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss">
.cancelDialogA {
  .v-btn {
    margin-top: 10px;
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  .v-dialog > .v-card > .v-card__title {
    padding: 0;
  }
  &_dialog {
    position: relative;
    &-cancel {
      color: #666 !important;
    }
    &-actions {
      text-align: center;
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-closeIcon {
      &.v-btn {
        &.v-btn--icon.v-size--default {
          position: absolute;
          right: 3px;
          top: 3px;
          z-index: 1;
        }

        .v-icon {
          margin-right: 0;
          font-size: 20px;
          color: #999;
          font-weight: bold;
        }

        &:not(.v-btn--text):not(.v-btn--outlined):hover:before,
        &.theme--light:hover::before {
          opacity: 0;
        }
      }
    }
    &-container {
      padding: 0 !important;
      .v-divider {
        border-color: #ccc;
      }
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
    &-text {
      padding: 0 !important;
      margin-top: 20px;
    }
    &-title {
      &.v-card__title {
        padding: 0 !important;
      }
      span {
        width: 100%;
        text-align: center;
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 14px;
        color: #666;
        font-weight: normal;
      }
    }
  }
}
</style>
